export default __webpack_public_path__ + "static/media/checked.2f2be5d1.svg";